import constants from '@/services/constants';
import ranksUtilities from '@/services/utilities/ranks';
import _ from 'lodash';

export default {
  areGeneralHandsInRange: function (generalHandStrings, generalHands) {
    let numGeneralHandsInRange = 0;
    let generalHand;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = generalHands.find(generalHandString);

      if (generalHand.inRange === true) {
        numGeneralHandsInRange++;
      }
    }, this);

    if (numGeneralHandsInRange === 0) {
      return false;
    } else if (numGeneralHandsInRange === generalHandStrings.length) {
      return true;
    } else if (numGeneralHandsInRange < generalHandStrings.length) {
      return 'partially';
    } else {
      throw new Error('Problem determining whether general hand strings are in range.');
    }
  },
  getGeneralHandStringFromSpecificHandString: function (specificHandString) {
    let rank1 = specificHandString[0];
    let rank2 = specificHandString[2];
    let suit1 = specificHandString[1];
    let suit2 = specificHandString[3];
    let suitedLetter;

    if (rank1 === rank2) {
      suitedLetter = '';
    } else if (suit1 === suit2) {
      suitedLetter = 's';
    } else {
      suitedLetter = 'o';
    }

    return rank1 + rank2 + suitedLetter;
  },
  getAllSpecificHandStringsFromGeneralHandString: function (generalHandString) { // duplicated elsewhere because of cyclic dependency issues
    let specificHandStrings = [];
    let rankOne = generalHandString[0];
    let rankTwo = generalHandString[1];
    let suitedOffsuitOrPair;

    if (generalHandString.length >= 4) {
      throw new Error('Invalid value of generalHandString.');
    }

    if (generalHandString[2] === 's') {
      suitedOffsuitOrPair = 'suited';
    } else if (generalHandString[2] === 'o') {
      suitedOffsuitOrPair = 'offsuit';
    } else {
      suitedOffsuitOrPair = 'pair';
    }

    if (suitedOffsuitOrPair === 'pair') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'd');
    }

    else if (suitedOffsuitOrPair === 'suited') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 's' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'd');
    }

    else if (suitedOffsuitOrPair === 'offsuit') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'h');
    }

    return specificHandStrings;
  },
  getSpecificHandStringsFromGeneralHandStrings: function (generalHandStrings) {
    let specificHandStrings = [];
    let specificHandStringsFromGeneralHandString;

    generalHandStrings.forEach(function (generalHandString) {
      specificHandStringsFromGeneralHandString = this.getAllSpecificHandStringsFromGeneralHandString(generalHandString);
      specificHandStrings.pushEachElement(specificHandStringsFromGeneralHandString);
    }, this);

    return specificHandStrings;
  },
  getNormalizedSpecificHandString: function (specificHandString) { // eg. asac --> acas
    let rank1 = specificHandString[0];
    let rank2 = specificHandString[2];
    let suit1 = specificHandString[1];
    let suit2 = specificHandString[3];
    let isAPair = rank1 === rank2;
    let suitOrder = ['c', 's', 'h', 'd'];
    let suitOneIndex = suitOrder.indexOf(suit1);
    let suitTwoIndex = suitOrder.indexOf(suit2);

    if (!isAPair) {
      return specificHandString;
    }


    if (suitOneIndex > suitTwoIndex) {
      return rank1 + suit2 + rank2 + suit1;
    } else {
      return rank1 + suit1 + rank2 + suit2;
    }
  },
  getAscendingGeneralHandStrings: function (generalHandString) {
    let firstRank = generalHandString[0];
    let secondRank = generalHandString[1];
    let spaceBetweenRanks = ranksUtilities.getSpaceBetweenRanks([firstRank, secondRank]);

    // jj+
    if (firstRank === secondRank) {
      return this._getAscendingPairGeneralHandStrings(firstRank);
    }

    // 65s+ or 64s+
    else if (spaceBetweenRanks === 1 || spaceBetweenRanks === 2) {
      return this._getAscendingConnectorOrOneGapperGeneralHandStrings(generalHandString, firstRank, spaceBetweenRanks);
    }

    // ajs+, ajo+ or aj+
    else {
      return this._getAscendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString);
    }
  },
  _getAscendingPairGeneralHandStrings: function (lowRank) {
    let ascendingGeneralHandStrings = [];

    ranksUtilities.forEachRank('a', lowRank, function (rank) {
      ascendingGeneralHandStrings.push(rank + rank);
    });

    return ascendingGeneralHandStrings;
  },
  _getAscendingConnectorOrOneGapperGeneralHandStrings: function (generalHandString, lowRank, spaceBetweenRanks) {
    let highRankIndex = 0; // (ace)
    let lowRankIndex = constants.ranks.indexOf(lowRank); // 8 (six)
    let ascendingGeneralHandStrings = [];

    // a..6
    for (let i = highRankIndex; i <= lowRankIndex; i++) {
      if (generalHandString[2] === 's') {
        ascendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 's');
      } else if (generalHandString[2] === 'o') {
        ascendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 'o');
      } else {
        ascendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 's');
        ascendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 'o');
      }
    }

    return ascendingGeneralHandStrings;
  },
  _getAscendingOtherGeneralHandStrings: function (firstRank, secondRank, generalHandString) {
    let ascendingGeneralHandStrings = [];

    // k..j
    ranksUtilities.forEachRank(ranksUtilities.getRankOneLower(firstRank), secondRank, function (rank) {
      if (generalHandString[2] === 's') {
        ascendingGeneralHandStrings.push(firstRank + rank + 's');
      } else if (generalHandString[2] === 'o') {
        ascendingGeneralHandStrings.push(firstRank + rank + 'o');
      } else {
        ascendingGeneralHandStrings.push(firstRank + rank + 's');
        ascendingGeneralHandStrings.push(firstRank + rank + 'o');
      }
    });

    return ascendingGeneralHandStrings;
  },
  getDescendingGeneralHandStrings: function (generalHandString) {
    let firstRank = generalHandString[0];
    let secondRank = generalHandString[1];
    let spaceBetweenRanks = ranksUtilities.getSpaceBetweenRanks([firstRank, secondRank]);

    // jj-
    if (firstRank === secondRank) {
      return this._getDescendingPairGeneralHandStrings(firstRank);
    }

    // 65s- or 64s
    else if (spaceBetweenRanks === 1 || spaceBetweenRanks === 2) {
      return this._getDescendingConnectorOrOneGapperGeneralHandStrings(generalHandString, firstRank, spaceBetweenRanks);
    }

    // ajs+, ajo+ or aj+
    else {
      return this._getDescendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString);
    }
  },
  _getDescendingPairGeneralHandStrings: function (highRank) {
    let descendingGeneralHandStrings = [];

    ranksUtilities.forEachRank(highRank, '2', function (rank) {
      descendingGeneralHandStrings.push(rank + rank);
    });

    return descendingGeneralHandStrings;
  },
  _getDescendingConnectorOrOneGapperGeneralHandStrings: function (generalHandString, highRank, spaceBetweenRanks) {
    let highRankIndex = constants.ranks.indexOf(highRank);
    let lowRankIndex = constants.ranks.indexOf('2');
    let descendingGeneralHandStrings = [];

    for (let i = highRankIndex; i <= lowRankIndex - spaceBetweenRanks; i++) {
      if (generalHandString[2] === 's') {
        descendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 's');
      } else if (generalHandString[2] === 'o') {
        descendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 'o');
      } else {
        descendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 's');
        descendingGeneralHandStrings.push(constants.ranks[i] + constants.ranks[i + spaceBetweenRanks] + 'o');
      }
    }

    return descendingGeneralHandStrings;
  },
  _getDescendingOtherGeneralHandStrings: function (firstRank, secondRank, generalHandString) {
    let descendingGeneralHandStrings = [];

    // k..j
    ranksUtilities.forEachRank(secondRank, '2', function (rank) {
      if (generalHandString[2] === 's') {
        descendingGeneralHandStrings.push(firstRank + rank + 's');
      } else if (generalHandString[2] === 'o') {
        descendingGeneralHandStrings.push(firstRank + rank + 'o');
      } else {
        descendingGeneralHandStrings.push(firstRank + rank + 's');
        descendingGeneralHandStrings.push(firstRank + rank + 'o');
      }
    });

    return descendingGeneralHandStrings;
  },
  getAllSpecificHandStringsUsingCard: function (card) {
    // eg. js --> acjs, asjs, ahjs, adjs..., jcjs, jsjh, jsjd..., tcjs, tsjs, thjs, tdjs...
    let cardRank = card[0];
    let cardSuit = card[1];
    let specificHandsUsingCard = [];

    constants.ranks.forEach(function (currRank) {
      if (currRank !== cardRank) {
        if (ranksUtilities.isFirstRankLargerThanSecond(currRank, cardRank)) {
          specificHandsUsingCard.push(currRank + 'c' + card); // eg. acjs
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(currRank + 'h' + card);
          specificHandsUsingCard.push(currRank + 'd' + card);
        } else {
          specificHandsUsingCard.push(card + currRank + 'c'); // eg. jstc
          specificHandsUsingCard.push(card + currRank + 's');
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        }
      }

      else if (currRank === cardRank) {
        if (cardSuit === 'c') {
          specificHandsUsingCard.push(card + currRank + 's');
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 's') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 'h') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 'd') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(currRank + 'h' + card);
        }
      }
    });

    return specificHandsUsingCard;
  },
  getGeneralHandStringsToAddFromDoubleSlider: function (topPercentile, bottomPercentile, generalHands, handRankings) {
    let generalHandStringsUpToTopPercentile = this._getGeneralHandStringsUpToGivenPercentile(topPercentile, generalHands, handRankings);
    let generalHandStringsUpToBottomPercentile = this._getGeneralHandStringsUpToGivenPercentile(bottomPercentile, generalHands, handRankings);
    return _.difference(generalHandStringsUpToTopPercentile, generalHandStringsUpToBottomPercentile);
  },
  _getGeneralHandStringsUpToGivenPercentile: function (percentile, generalHands, handRankings) {
    let currPercentage = 0;
    let numSpecificHandsAdded = 0;
    let generalHandIndex = 0;
    let generalHandStringsUpToGivenPercentile = [];
    let currGeneralHand;

    while (currPercentage < percentile) {
      currGeneralHand = this.__getCurrGeneralHand(generalHands, handRankings, generalHandIndex);

      if (currGeneralHand.possible) {
        generalHandStringsUpToGivenPercentile.push(currGeneralHand.string);
        numSpecificHandsAdded += currGeneralHand.numPossibleSpecificHands;
        currPercentage = (numSpecificHandsAdded / generalHands.numberOfPossibleSpecificHands) * 100;
      }

      generalHandIndex++;
    }

    return generalHandStringsUpToGivenPercentile;
  },
  __getCurrGeneralHand: function (generalHands, handRankings, generalHandIndex) {
    let generalHandString = handRankings[generalHandIndex];

    return generalHands.find(generalHandString);
  },
  getGeneralHandsToUseForSimulation: function (player, presetCommunityCards, simulateTo) {
    return this._getPlayerStateToUseForSimulation(player, presetCommunityCards, simulateTo).generalHands;
  },
  getNameOfStateToUseForSimulation: function (player, presetCommunityCards, simulateTo) {
    return this._getPlayerStateToUseForSimulation(player, presetCommunityCards, simulateTo).name;
  },
  _getPlayerStateToUseForSimulation: function (player, presetCommunityCards, simulateTo) {
    if (simulateTo === 'flop') {
      return player.states[0];
    }

    else if (simulateTo === 'turn') {
      if (presetCommunityCards.numSet >= 3) {
        return player.states[1];
      } else {
        return player.states[0];
      }
    }

    else if (simulateTo === 'river') {
      if (presetCommunityCards.numSet >= 4) {
        return player.states[2];
      } else if (presetCommunityCards.numSet === 3) {
        return player.states[1];
      } else {
        return player.states[0];
      }
    }

    else {
      throw new Error('Invalid value for simulateTo.');
    }
  },
  getWeightedRangeFromGeneralHandString: function (generalHandString, presetCommunityCardsArray) {
    let specificHandStrings = this.getAllSpecificHandStringsFromGeneralHandString(generalHandString);
    let weightedRange = [];
    let firstCard;
    let secondCard;

    specificHandStrings.forEach(function (specificHandString) {
      firstCard = specificHandString.substring(0, 2);
      secondCard = specificHandString.substring(2, 4);

      if (!presetCommunityCardsArray.includes(firstCard) && !presetCommunityCardsArray.includes(secondCard)) {
        weightedRange.push([ firstCard, secondCard ]);
      }
    });

    return weightedRange;
  },
};



// WEBPACK FOOTER //
// ./src/services/utilities/hands.js